import gql from "graphql-tag";
const CREATE_AUDIENCE_DEMOGRAPH = gql`
  mutation createAudienceDemograph(
    $name: String!
    $description: String
    $tags: [String!]
    $orgID: ID!
    $metrics: [Json!]!
    $reachCount: Int
    $createdBy: ID
  ) {
    createAudienceDemograph(
      data: {
        name: $name
        description: $description
        tags: { set: $tags }
        metrics: { set: $metrics }
        reachCount: $reachCount
        org: { connect: { id: $orgID } }
        createdBy: { connect: { id: $createdBy } }
      }
    ) {
      id
      name
    }
  }
`;

export default CREATE_AUDIENCE_DEMOGRAPH;
